import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';
import { userAccountSettingsActions } from '@/Pages/Settings/modules/AccountSettings/services/reducer';
import { useDispatch } from 'react-redux';

export function useAccountSettings() {
  const dispatch = useDispatch();

  const {
    tours: {
      AccountSettings: { Default, AccountSettings },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Default.Title,
      steps: [
        {
          content: Default.Step1.Text,
          placement: 'auto',
          target: '#regionalSettingsTitle',
          title: Default.Step1.Title,
          disableBeacon: true,
          link: Default.Step1.DetailsLink,
        },
        {
          content: Default.Step2.Text,
          placement: 'auto',
          target: '.regionalSettingsBtn',
          title: Default.Step2.Title,
          disableBeacon: true,
          link: Default.Step2.DetailsLink,
        },
        {
          content: Default.Step3.Text,
          placement: 'auto',
          target: '.paymentMethodsBtn',
          title: Default.Step3.Title,
          disableBeacon: true,
          link: Default.Step3.DetailsLink,
        },
        {
          content: Default.Step4.Text,
          placement: 'auto',
          target: '.basicSettings',
          title: Default.Step4.Title,
          disableBeacon: true,
          link: Default.Step4.DetailsLink,
        },
        {
          content: Default.Step5.Text,
          placement: 'auto',
          target: '.additionalSettings',
          title: Default.Step5.Title,
          disableBeacon: true,
          link: Default.Step5.DetailsLink,
        },
        {
          content: Default.Step6.Text,
          placement: 'auto',
          target: '.additionalEditableSettings',
          title: Default.Step6.Title,
          disableBeacon: true,
          link: Default.Step6.DetailsLink,
        },
        {
          content: Default.Step7.Text,
          placement: 'auto',
          target: '.basicParameters',
          title: Default.Step7.Title,
          disableBeacon: true,
          link: Default.Step7.DetailsLink,
        },
      ],
    }),
    [Default],
  );

  const accountSettingsTour = useMemo<TourType>(
    () => ({
      id: 'accountSettingsTour',
      title: AccountSettings.Title,
      before: () => {
        dispatch(userAccountSettingsActions.setRegionalSettingModal(true));
      },
      steps: [
        {
          content: AccountSettings.Step1.Text,
          placement: 'auto',
          target: '.basicTimezoneSettings',
          title: AccountSettings.Step1.Title,
          disableBeacon: true,
          link: AccountSettings.Step1.DetailsLink,
        },
        {
          content: AccountSettings.Step2.Text,
          placement: 'auto',
          target: '.extraTimezoneSettings',
          title: AccountSettings.Step2.Title,
          disableBeacon: true,
          link: AccountSettings.Step2.DetailsLink,
        },
        {
          content: AccountSettings.Step3.Text,
          placement: 'auto',
          target: '.currencyTable',
          title: AccountSettings.Step3.Title,
          disableBeacon: true,
          link: AccountSettings.Step3.DetailsLink,
        },
      ],
    }),
    [AccountSettings],
  );

  return [pageTour, accountSettingsTour];
}
